export default __webpack_public_path__ + "static/media/bf.9009ba27.svg";